 jQuery(document).ready(function () {
    openSubmenu();
    toggleSearchform();
    toggleVehiculeOccasionTabs();
    linkPrintDocument();
    initSortByPosts()
});

var counter_effect = false;
jQuery(window).scroll(function(){
    // Activer l'effet Compteur quand on arrive dessus
    if(jQuery('.pgut-counter__number').length > 0){
        var top_window = jQuery('.pgut-grid-counter').offset().top - window.innerHeight;
        if(!counter_effect && top_window && jQuery(window).scrollTop() > top_window){
            counter_effect = true;
            counterEffect(false);
        }

        if((jQuery(window).scrollTop() > (jQuery('.pgut-grid-counter').offset().top + jQuery('.pgut-grid-counter').height())) || (((jQuery(window).scrollTop() + jQuery(window).height()) < (jQuery('.pgut-grid-counter').offset().top)))){
            counterEffect(true);
            counter_effect = false;
        }
    }
});


// Animation de compteur de chiffres
function counterEffect($reset = false) {
    jQuery('.pgut-counter__number').each(function () {
        var $this = jQuery(this);
        var split_string = $this.attr('data-number').split(",");
        if($reset){
            if(split_string.length > 1){
                jQuery.each(split_string, function(i, $val){
                    $this.text(0);
                });
            }
            else {
                $this.text(0);
            }
        }
        else {
            // Pour les nombres à décimales
            // On coupe la chaine en 2 et on fait deux compteurs différents
            if(split_string.length > 1){
                $this.html("<span class='pgut-counter__number-part'>"+split_string[0]+"</span>,<span class='pgut-counter__number-part'>"+split_string[1]+"</span>");
                jQuery.each(split_string, function(i, $val){;
                    $val = $this.find('.pgut-counter__number-part').eq(i).text();
                    jQuery({ Counter: 0 }).animate({ Counter: $this.find('.pgut-counter__number-part').eq(i).text() }, {
                        duration: 1000,
                        easing: 'swing',
                        step: function (now) {
                            $this.find('.pgut-counter__number-part').eq(i).text(Math.ceil(now).toLocaleString('en'));
                        }
                    });
                });
            }
            else {
                jQuery({ Counter: 0 }).animate({ Counter: $this.attr('data-number') }, {
                    duration: 1000,
                    easing: 'swing',
                    step: function (now) {
                        $this.text(Math.ceil(now).toLocaleString('en'));
                    }
                });
            }
        }
    });
}

function openSubmenu(){
    // For responsive devices
    if(jQuery('.wp-block-navigation__submenu-icon').length > 0){
        jQuery('.wp-block-navigation__submenu-icon').on('click', function(){
            var submenu_icon = jQuery(this);
            setTimeout(function(){
                if(submenu_icon.attr('aria-expanded') === 'true'){
                    submenu_icon.parent().addClass('pgut-submenu__open');
                    //submenu_icon.parent().find('.acf-innerblocks-container > .pgut-index-pages > .pgut-index-pages__group').addClass('pgut-index-pages__group__open');
                }
                else {
                    submenu_icon.parent().removeClass('pgut-submenu__open');
                    //submenu_icon.parent().find('.acf-innerblocks-container > .pgut-index-pages > .pgut-index-pages__group').aremoveClass('pgut-index-pages__group__open');
                }
            }, 100);
        });
    }

    if(jQuery('.pgut-index-pages__icon').length > 0){
        jQuery('.pgut-index-pages__icon').on('click', function(){
            var submenu_icon = jQuery(this);
            setTimeout(function(){
                submenu_icon.parent().toggleClass('pgut-index-pages__group__open');
            }, 100);
        });
    }

    // For desktop
    if(jQuery('.wp-block-navigation__container > .wp-block-navigation-item.has-child').length > 0){
        jQuery('.wp-block-navigation__container > .wp-block-navigation-item.has-child').on('mouseover',function(){
            jQuery('header > .pgut-header__content > .wp-block-group').addClass('pgut-header__content__dark-background');
        });

        jQuery('.wp-block-navigation__container > .wp-block-navigation-item.has-child').on('mouseout',function(){
            jQuery('header > .pgut-header__content > .wp-block-group').removeClass('pgut-header__content__dark-background');
        });
    }
}

function toggleSearchform(){
    if(jQuery('.pgut-search').length > 0) {
        jQuery('.pgut-search__content').on('click', function () {
            jQuery(this).parent().toggleClass('pgut-search__open');

            if(jQuery(this).parent().hasClass('pgut-search__open')){
                jQuery('#pgut-searchform > input[type="text"]').focus();
            }
        });

        jQuery('.pgut-search__content__opened .pgut-icon').on('click', function () {
            jQuery(this).closest('.pgut-search').toggleClass('pgut-search__open');
        });
    }
}

function toggleVehiculeOccasionTabs(){
    if(jQuery('.pgut-vehicule-occasion-tabs').length > 0){
        jQuery('.pgut-vehicule-occasion-tabs__tablink').on('click', function(){
            jQuery('.pgut-vehicule-occasion-tabs div[role="tabpanel"]:not(.is-hidden)').addClass('is-hidden');
            jQuery(this).parent().find('.pgut-vehicule-occasion-tabs__tablink[aria-selected="true"]').attr('aria-selected',false).attr('tabindex', '-1');
            jQuery(this).attr('aria-selected',true).removeAttr('tabindex');

            var tabpanel_to_open = '#'+jQuery(this).attr('aria-controls');
            jQuery(tabpanel_to_open).removeClass('is-hidden');
        });
    }
}

function linkPrintDocument(){
    if(jQuery('.pgut-button-print').length > 0){
        jQuery('.pgut-button-print').on('click', function(e){
            e.preventDefault();
            window.print();
        });
    }
}

function initSortByPosts(){
    if(jQuery('#pgut-sort-by').length > 0){
        jQuery('#pgut-sort-by').on('change', function(){
            var sortValue = jQuery(this).val();
            var currentUrl = new URL(window.location.href);
            var params = new URLSearchParams(currentUrl.search);

            // Update the sort_by parameter
            params.set('sort_by', sortValue);

            // Reload the page with the updated query parameters
            window.location.href = currentUrl.pathname + '?' + params.toString();
        });
    }
}